/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OfferTriggers = 'Waive' | 'Completed' | 'Revise' | 'Submit' | 'Withdraw' | 'Disqualify';

export const OfferTriggers = {
    Waive: 'Waive' as OfferTriggers,
    Completed: 'Completed' as OfferTriggers,
    Revise: 'Revise' as OfferTriggers,
    Submit: 'Submit' as OfferTriggers,
    Withdraw: 'Withdraw' as OfferTriggers,
    Disqualify: 'Disqualify' as OfferTriggers
};

